import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { trackWhatsAppClick } from './MetaPixel';
export function FinalCTA() {
  return <section className="relative py-32 md:py-48 flex items-center justify-center overflow-hidden" data-id="element-82">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-83">
        <img src="https://cdn.magicpatterns.com/uploads/3uxr8pkgt9rQrSsRewzUAF/ChatGPT_Image_18_may_2026,_10_15_58.png" alt="Amanecer esperanza" className="w-full h-full object-cover object-center" data-id="element-84" />
        <div className="absolute inset-0 bg-ink/80" data-id="element-85"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-transparent to-ink/50" data-id="element-86"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10 text-center" data-id="element-87">
        <motion.div className="max-w-3xl mx-auto" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-88">
          <h2 className="text-5xl md:text-7xl font-serif text-ivory-bright mb-10 leading-tight" data-id="element-89">
            Todo cambia cuando decides{' '}
            <span className="text-gold italic" data-id="element-90">volver a ti</span>
          </h2>

          <div className="space-y-6 text-lg text-ivory/90 font-light mb-12" data-id="element-91">
            <p data-id="element-92">
              Muchas personas siguen esperando que algo externo cambie sus
              vidas. Pero la verdadera transformación comienza cuando decides
              reconstruirte desde adentro.
            </p>
            <p data-id="element-93">
              No importa cuántas veces hayas tenido que empezar de nuevo.
              Siempre puedes volver a levantarte.
            </p>
            <p className="text-muted" data-id="element-94">
              Pero llega un momento donde seguir postergando tu paz emocional
              también tiene un costo. Porque mientras sigues esperando… la
              ansiedad continúa drenando tu energía, tus relaciones, tu enfoque
              y tu tranquilidad interior.
            </p>
          </div>

          <div className="mb-12" data-id="element-95">
            <p className="font-serif text-3xl md:text-4xl text-ivory-bright" data-id="element-96">
              NO NACISTE PARA VIVIR EN ANSIEDAD.
              <br data-id="element-97" />
              <span className="font-script text-5xl md:text-7xl text-gold block mt-4" data-id="element-98">
                Naciste para volver a ti.
              </span>
            </p>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} data-id="element-99">
            <a href="https://wa.me/5491145263003" target="_blank" rel="noopener noreferrer" onClick={trackWhatsAppClick} className="inline-flex items-center justify-center gap-3 px-10 py-5 bg-[#25D366] text-white hover:bg-[#1DA851] transition-all duration-300 font-medium tracking-wide group text-lg shadow-xl shadow-[#25D366]/25" data-id="element-100">
              <MessageCircle className="w-6 h-6 group-hover:scale-110 transition-transform" data-id="element-101" />
              QUIERO HABLAR CON FREDDY
            </a>
            <p className="mt-6 text-sm text-muted flex items-center justify-center gap-2" data-id="element-102">
              <span className="text-gold" data-id="element-103">⚠️</span> Mentoría personalizada •
              Atención limitada según disponibilidad.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}